import { render, staticRenderFns } from "./StyledWebcam.vue?vue&type=template&id=0a66dafc&"
import script from "./StyledWebcam.vue?vue&type=script&lang=js&"
export * from "./StyledWebcam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports